import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE_VEHICLES_MODELS = {
  'vehicles': [],
  'loading': false,
};

export const vehiclesModels = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_MODELS, {
    [ActionTypes.FETCHING_VEHICLES_MODEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_MODEL]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_MODEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': [],
    }),
    [ActionTypes.DELETING_VEHICLES_MODEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_VEHICLES_MODEL]: (state, action) => {
      const vehicles = state.vehicles.filter((vehicle) => vehicle.id !== action.payload);
      return {
        ...state,
        'loading': false,
        'vehicles': vehicles,
      };
    },
    [ActionTypes.DELETE_VEHICLES_MODEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
